<template>
  <div
    class="control-page"
    :class="{
      'control-page--is-mobile': isMobile,
      'control-page--show-nav': showNavigation,
      'control-page--preview-demo': !!Number(previewDemo),
    }"
  >
    <div class="control-page__aside">
      <div
        class="control-page__overlay"
        @click="setShowNavigation(false)"
      ></div>

      <div class="control-page__settings">
        <button
          type="button"
          class="control-page__close-btn"
          @click="setShowNavigation(!showNavigation)"
        >
          <v-icon class="control-page__close-icon">{{ showNavigation ? 'mdi-close' : 'mdi-cog-outline' }}</v-icon>
        </button>

        <perfect-scrollbar
          class="control-page__settings-scroll"
          :options="{
            suppressScrollX: true,
            wheelPropagation: false,
          }"
        >
          <ControlPanel />
        </perfect-scrollbar>
      </div>
    </div>

    <div class="control-page__content">
      <div class="control-page__wrap">
        <ControlWidget />
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, onBeforeUnmount, computed, watch} from 'vue';

import ControlPanel from './ControlPanel/ControlPanel.vue';
import ControlWidget from './ControlWidget/ControlWidget.vue';
import {useStore} from "vuex";
import { useRoute } from 'vue-router'

export default {
  components: {
    ControlPanel,
    ControlWidget,
  },
  setup() {
    const isMobile = ref(false);
    const showNavigation = ref(false);
    const store = useStore();

    const previewDemo = computed(() => {
      return  store.getters['control/previewDemo'];
    });

    watch(previewDemo, () => {
      resizeHandler();
    })

    const setShowNavigation = function (state) {
      showNavigation.value = state;
    };

    const resizeHandler = async function () {
      if ( Number(useRoute()?.query?.['preview-demo']) ) {
        setTimeout(() => {
          isMobile.value = !!Number(previewDemo.value) || window.innerWidth < 960;
        }, 200)
      } else {
        isMobile.value = !!Number(previewDemo.value) || window.innerWidth < 960;
      }
    };

    resizeHandler();

    onMounted(() => {
      window.addEventListener('resize', resizeHandler, { passive: true });
    });

    onBeforeUnmount(() => {
      window.removeEventListener('resize', resizeHandler, { passive: true });
    });

    return {
      isMobile,
      showNavigation,
      setShowNavigation,
      previewDemo,
    };
  },
};
</script>

<style lang="scss">
.control-page {
  $this: 'control-page';
  $panelSize: 320px;

  &--is-mobile {
    .#{$this}__settings {
      transform: translateX(-100%);
    }

    .#{$this}__close-btn {
      display: block;
      transform: translateX(5px);
    }

    .#{$this}__content {
      width: 100%;
      position: relative;
      z-index: 1;
    }
  }

  &--show-nav {
    &.#{$this}--is-mobile {
      .#{$this}__overlay {
        opacity: 0.4;
        pointer-events: all;
      }

      .#{$this}__settings {
        transform: translateX(0);
      }

      .#{$this}__close-btn {
        transform: translateX(0);
      }
    }
  }

  &--preview-demo {
    &.#{$this}--is-mobile {
      @media screen and (max-width: 599px) {
        height: 100%;

        .control-page__content {
          padding: 0 !important;
          height: 100%;
          display: flex;

          .control-page__wrap {
            display: flex;
          }

        }
      }
    }
  }

  &__aside {
    position: fixed;
    z-index: 1001;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
  }

  &__overlay {
    height: 100%;
    background-color: rgb(33, 33, 33);
    opacity: 0;
    pointer-events: none;
    transition: opacity $anim-base;
  }

  &__settings {
    width: calc(100% - 30px);
    max-width: $panelSize;
    height: 100%;
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: $color-white;
    pointer-events: all;
    transition: transform $anim-base;
  }

  &__close-btn {
    position: absolute;
    top: 4px;
    right: -30px;
    z-index: 1;
    padding: 15px;
    line-height: 0;
    transition: transform $anim-base;
    display: none;
  }

  &__close-icon {
    background-color: $color-white;
    border-radius: 50%;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2),
      0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
    font-size: 18px;
    height: 30px;
    width: 30px;
  }

  &__settings-scroll {
    height: 100%;
    padding: 25px 40px;
  }

  &__content {
    width: calc(100% - #{$panelSize});
    padding: 5px 10px;
    margin-left: auto;
  }

  // &__wrap {
  //   max-width: 820px;
  //   margin: 0 auto;
  // }
}
</style>
